import type { Data } from '@repo/strapi'
import AppLink from '@/components/elementary/AppLink'
import { CATEGORY_PAGE_PATH } from '@/lib/constants'
import { cn } from '@/lib/styles'
import { BLOG_CATEGORIES_ROW_TEST_IDS } from '@/lib/test-ids'

export function BlogCategoriesRow({
	categories,
	type = 'large',
}: {
	categories: Data.ContentType<'api::blog-category.blog-category'>[]
	type?: 'small' | 'large'
}) {
	return categories?.length > 0 ? (
		<span
			className="bodyRegularMedium flex flex-wrap"
			data-test-id={BLOG_CATEGORIES_ROW_TEST_IDS.COMPONENT}
		>
			{categories.map(
				(category: Data.ContentType<'api::blog-category.blog-category'>, index: number) => (
					<span key={category.id} className="flex items-center">
						<span className={cn('mx-1 leading-none', index === 0 && 'hidden')}>·</span>
						<AppLink
							variant="quaternaryLink"
							className="no-underline"
							href={`${CATEGORY_PAGE_PATH}/${category.slug}`}
							data-test-id={BLOG_CATEGORIES_ROW_TEST_IDS.LINK}
						>
							<span className={cn(type === 'small' && 'text-base/4')}>{category.name}</span>
						</AppLink>
					</span>
				),
			)}
		</span>
	) : null
}
